import React, { useState, useEffect } from "react";

const RightToLeftLayout = () => {
    const [isRightToLeft, setIsRightToLeft] = useState(false);

    useEffect(() => {
        if (isRightToLeft) {
            document.body.classList.add("right-left-layout");
        } else {
            document.body.classList.remove("right-left-layout");
        }
    }, [isRightToLeft]);

    const toggleLayout = () => {
        setIsRightToLeft(prevState => !prevState);
    };

    return (
        <div className="setting-item">
            <label htmlFor="rtl-toggle" className="setting-label">
                <input
                    id="rtl-toggle"
                    type="checkbox"
                    checked={isRightToLeft}
                    onChange={toggleLayout}
                    className="setting-checkbox"
                />
                <span className="setting-text">Right-to-Left Layout</span>
            </label>
        </div>
    );
};

export default RightToLeftLayout;
